import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "@welldigital/components/font/index.css";
import "./index.css";

import App from "./app";
import ReactDOM from "react-dom";

// mocking server response for development ease
// import * as requests from "@welldigital/ui-common/Authentication/requests";
// // @ts-ignore
// requests.getUserProfileTargets = () => {
//   return new Promise((res) =>
//     res({
//       email: "c@c.cc",
//       targetList: [
//         "pharmacy",
//         "customer",
//         "online-services",
//         "instore-services",
//       ],
//     })
//   );
// };

ReactDOM.render(<App />, document.querySelector("#root"));
